import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useLoader } from './context/LoadingContext';
import { setupAxiosInterceptors } from './utils/axiosConfig';
import { AuthProvider } from './context/AuthContext';
import Loader from './componenets/Loader';
import Register from './Register';
import Profile from './Profile';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';
import OTPverificationPage from './OTPverificationPage';
import TopNavbar from './TopNavbar';
import Protected from './Protected';
import RoleList from './RoleList';
import Login from './login';
import ForgotPassword from './ForgotPassword';
import ModuleList from './componenets/ModuleList';
import InstanceList from './componenets/instance/InstanceList';
import TenantList from './componenets/tenant/TenantList';
import LicenseList from './componenets/license/LicenseList';
import InstanceDetails from './componenets/instance/InstanceDetails';
import FirstPage from './componenets/FirstPage';
import TenantDetails from './componenets/tenant/TenantDetails';
import LicenseView from './componenets/license/LicenseView';
import IndustryDetails from './componenets/tenant/IndustryDetails';
import ClientList from './componenets/client/ClientList';
import ClientDetails from './componenets/client/ClientDetails';
import VendorDetails from './componenets/client/VendorDetails';
import ProductList from './componenets/product/ProductList';
import ProductDetails from './componenets/product/ProductDetails';
import CategoryDetails from './componenets/product/CategoryDetails';
import BrandDetails from './componenets/product/BrandDetails';
import ProjectList from './componenets/project/ProjectList';
import ProjectDetails from './componenets//project/ProjectDetails';
import QuotationList from './componenets/quotation/QuotationList';
import QuotationDetails from './componenets/quotation/QuotationDetails';
import ContactsDetails from './componenets/contact/ContactsDetails';
import SelectedContactDetails from './componenets//contact/SelectedContactDetails';
import SettingsDetails from './componenets/setting/SettingsDetails';
import EntryTypeList from './componenets/setting/EntryTypeList';
import PurchaseOrderDetails from './componenets/purchaseorder/PurchaseOrderDetails';
import PurchaseOrderList from './componenets/purchaseorder/PurchaseOrderList';
import CountryDetails from './componenets/setting/CountryDetails';
import ProformaInvoiceList from './componenets/ProformaInvoice/ProformaInvoiceList';
import ProformaInvoiceDetails from './componenets/ProformaInvoice/ProformaInvoiceDetails';
import TaxInvoiceDetails from './componenets/ProformaInvoice/TaxInvoiceDetails';
import TaxDetailsList from './componenets/ProformaInvoice/TaxDetailsList';
import OrganisationList from './componenets/sales/organisation/OrganisationList';
import OrganisationDetails from './componenets/sales/organisation/OrganisationDetails';
import UserDetails from './componenets/user/UserDetails';
import RoleDetails from './componenets/user/RoleDetails';
import PermissionDetails from './componenets/user/PermissionDetails';
import AllTenantList from './componenets/tenant/AllTenantList';
import LeadList from './componenets/sales/lead/LeadList';
import LeadDetails from './componenets/sales/lead/LeadDetails';
import DealList from './componenets/sales/deal/DealList';
import DealDetails from './componenets/sales/deal/DealDetails';
import ActivityDetails from './componenets/sales/lead/activity/ActivityDetails';
import DealsbyStage from './componenets/sales/deal/DealsbyStage';
import PartnerList from './componenets/sales/partner/PartnerList';
import PartnerDetails from './componenets/sales/partner/PartnerDetails';
import OrderDealList from './componenets/sales/deal/OrderDealList';
import InvoiceList from './componenets/client/InvoiceList';
import ContactTypeDetails from './componenets/contact/ContactTypeDetails';
import ExpenseTypeDetails from './componenets/account/expense/ExpenseTypeDetails';
import AllExpenseList from './componenets/project/expense/AllExpenseList';
import BankList from './componenets/account/bank/BankList';
import BankDetails from './componenets/account/bank/BankDetails';
import TransactionList from './componenets/account/transactions/TransactionList';
import SystemTenant from './componenets/systemtenant/SystemTenant';
import SalesDashboard from './componenets/Dashboard/SalesDashboard';
import AccountDashboard from './componenets/Dashboard/AccountDashboard';
import DashboardRedirect from './componenets/Dashboard/DashboardRedirect';
import OperationDashboard from './componenets/Dashboard/OperationDashboard';
import TaxList from './componenets/account/Tax/TaxList';
import Balancesheet from './componenets/Reports/Balancesheet';
import ProfitAndLoss from './componenets/Reports/ProfitAndLoss';
import TrialBalance from './componenets/Reports/TrialBalance';
import LedgerStatement from './componenets/Reports/LedgerStatement';
import ReceivableAgingReport from './componenets/Reports/ReceivableAgingReport';
import PayableAgingReport from './componenets/Reports/PayableAgingReport';
import ExpenseReport from './componenets/Reports/ExpenseReport';
import ReconciliationReport from './componenets/Reports/ReconciliationReport';
import FrstPage from './FrstPage';
import EmployeeList from './componenets/HR/employee/EmployeeList';
import EmployeeDetails from './componenets/HR/employee/EmployeeDetails';
import AllowanceList from './componenets/HR/employee/AllowanceList';
import AttendanceReport from './componenets/HR/Attendence/AttendenceReport';
import LeaveTypeList from './componenets/HR/Leave/LeaveTypeList';
import LeaveEntitlement from './componenets/HR/Leave/LeaveEntitlement';
import LeaveApplication from './componenets/HR/Leave/LeaveApplication';
import PendingLeave from './componenets/HR/Leave/PendingLeave';
import HolidayList from './componenets/HR/Leave/HolidayList';
import PrefixList from './componenets/setting/PrefixList';
import EmployeeEvent from './componenets/HR/employee/EmployeeEvent';
import LoanList from './componenets/HR/Loan/LoanList';
import PendingLoan from './componenets/HR/Loan/PendingLoan';
import DeductionList from './componenets/HR/Loan/DeductionList';
import OvertimeList from './componenets/HR/Loan/OvertimeList';
import PayrollCycleList from './componenets/HR/Payroll/PayrollCycleList';
import PendingOT from './componenets/HR/Loan/PendingOT';
import OvertimeTypeList from './componenets/HR/Loan/OvertimeTypeList';
import RevenueRecognitionReport from './componenets/Reports/RevenueRecognitionReport';
import RevenueRecognitionList from './componenets/Reports/RevenueRecognitionList';
import ExpenseRecognitionReport from './componenets/Reports/ExpenseRecognitionReport';
import ReceivableReport from './componenets/Reports/ReceivableReport';
import StatementOfAccounts from './componenets/Reports/StatementOfAccounts';
import PartnerSOA from './componenets/Reports/PartnerSOA';
import ProductPricing from './componenets/product/ProductPricing';
import AMCSettings from './componenets/product/AMCSettings';
import AllQuotation from './componenets/quotation/AllQuotation';
import BankDetailList from './componenets/account/bank/BankDetailList';
import PODetails from './componenets/client/PODetails';
import ChartOfAccounts from './componenets/Reports/ChartOfAccounts';
import ActivityLogs from './componenets/setting/ActivityLogs';
import CashFlowStatement from './componenets/Reports/CashFlowStatement';
import FinancialLock from './componenets/setting/FinancialLock';
import PayrollProviderDetails from './componenets/account/transactions/PayrollProviderDetails';
import VATPaymentDetails from './componenets/account/transactions/VATPaymentDetails';
import ImportExportList from './componenets/account/transactions/ImportExportList';
import ActivityTypeList from './componenets/setting/ActivityTypeList';
import LicenseTypeList from './componenets/license/LicenseTypeList';
import DomainList from './componenets/domain/DomainList';
import SalesTargetAssignment from './componenets/sales/target/SalesTargetAssignment';
import DepartmentList from './componenets/user/DepartmentList';
import DealStageList from './componenets/setting/DealStageList';

import SetupInfoList from './componenets/v360-setup-info/SetupInfoList';
import LicenseInfoList from './componenets/v360-license-info/LicenseInfoList';
import LicenseKeyList from './componenets/v360-license-keys/LicenseKeyList';
import LicenseDashboard from './componenets/Dashboard/LicenseDashboard';
// const Layout = ({ children }) => {
//   const { isLoading } = useLoader();

//   return (
//     <div id="layout-wrapper">
//       <Header />
//       <Sidebar />
//       <main style={{ flex: 1, position: "relative"  , minHeight: "calc(100vh - 200px)"}}>
//         {isLoading && (
//           <div className="loaderoverlay">
//             <Loader />
//           </div>
//         )}
//         {children}
//       </main>
//       <Footer />
//     </div>
//   );
// };

const Layout = ({ children }) => {
  const { isLoading } = useLoader();

  return (
    <div id="layout-wrapper" className='layout1'>
      <Header />
      <Sidebar />
      <main className='main-class'>
        {isLoading && (
          <div className="loader-overlay">
            <Loader />
          </div>
        )}
        {children}
      </main>
      <Footer />
    </div>
  );
};

function App() {
  const { isLoading, setIsLoading } = useLoader();

  useEffect(() => {
    // Add or remove 'loading' class on <body> based on isLoading
    if (isLoading) {
      document.body.classList.add("loading");
    } else {
      document.body.classList.remove("loading");
    }
  }, [isLoading]);
  // useEffect(() => {
  //   setupAxiosInterceptors(setIsLoading);  // Ensure this is being called correctly

  //   // Global handler to disable scroll/arrow keys on number inputs
  //   const handleKeyDown = (e) => {
  //     if (e.target.type === 'number' && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
  //       e.preventDefault();
  //     }
  //   };

  //   const handleWheel = (e) => {
  //     if (e.target.type === 'number') {
  //       e.target.blur();
  //     }
  //   };

  //   window.addEventListener('keydown', handleKeyDown);
  //   window.addEventListener('wheel', handleWheel, { passive: false });

  //   return () => {
  //     window.removeEventListener('keydown', handleKeyDown);
  //     window.removeEventListener('wheel', handleWheel);
  //   };
  // }, [setIsLoading]);
  useEffect(() => {
    setupAxiosInterceptors(setIsLoading);

    const handleKeyDown = (e) => {
      // Check if it's a number input
      if (e.target.type === 'number') {
        // If it's NOT a quantity field, prevent arrow keys
        if (!e.target.classList.contains('quantity-input') &&
          e.target.name !== 'quantity' &&
          !e.target.id?.includes('quantity')) {

          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
            e.preventDefault();
          }
        }
        // If it IS a quantity field, allow arrow keys (do nothing)
      }
    };

    const handleWheel = (e) => {
      // Check if it's a number input
      if (e.target.type === 'number') {
        // If it's NOT a quantity field, prevent wheel changes
        if (!e.target.classList.contains('quantity-input') &&
          e.target.name !== 'quantity' &&
          !e.target.id?.includes('quantity')) {

          if (document.activeElement === e.target) {
            e.preventDefault(); // Prevent wheel from changing value
          }
        }
        // If it IS a quantity field, allow wheel changes (do nothing)
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('wheel', handleWheel);
    };
  }, [setIsLoading]);

  const user = JSON.parse(localStorage.getItem('user-info'));
  const origin = localStorage.getItem('user-origin');
  const token = user?.token;
  const isLoggedIn = !!token;
  function getDefaultDashboardByPermission(permissions = []) {
    if (permissions.includes("dashboard-main")) return "/dashboard";
    if (permissions.includes("dashboard-sales")) return "/sales-dashboard";
    if (permissions.includes("dashboard-account")) return "/account-dashboard";
    if (permissions.includes("dashboard-operation")) return "/operation-dashboard"; // optional
    return null;
  }
  // const options = {
  //   position: positions.TOP_RIGHT,
  //   timeout: 4000,
  //   offset: '40px',
  //   transition: transitions.SCALE,
  // };
  return (



    <Router>
      {/* {isLoading && <Loader />} */}

      <Routes>

        {/* Public routes (no Layout) */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verification" element={<OTPverificationPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />


        {/* Protected routes wrapped in Layout */}

        <Route
          path="/"
          element={
            isLoggedIn ? (
              (() => {
                const defaultPath = getDefaultDashboardByPermission(user.permissions);
                return defaultPath ? <Navigate to={defaultPath} replace /> : <Navigate to="/login" replace />;
              })()
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route path="/dashboard" element={<Protected><Layout><FirstPage /></Layout></Protected>} />
        <Route
          path="/modules"
          element={
            <Protected>
              <Layout>
                <ModuleList />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/instance"
          element={
            <Protected>
              <Layout>
                <InstanceList />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/tenants"
          element={
            <Protected>
              <Layout>
                <AllTenantList />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/expenses"
          element={
            <Protected>
              <Layout>
                <AllExpenseList />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/settings"
          element={
            <Protected>
              <Layout>
                <SettingsDetails />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/systemtenant"
          element={
            <Protected>
              <Layout>
                <SystemTenant />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/user"
          element={
            <Protected>
              <Layout>
                <UserDetails />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/roles"
          element={
            <Protected>
              <Layout>
                <RoleDetails />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/permission"
          element={
            <Protected>
              <Layout>
                <PermissionDetails />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/countries"
          element={
            <Protected>
              <Layout>
                <CountryDetails />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/setup-info"
          element={
            <Protected>
              <Layout>
                <SetupInfoList />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/license-info"
          element={
            <Protected>
              <Layout>
                <LicenseInfoList />
              </Layout>
            </Protected>
          }
        />
        <Route path="/organisation/details/:id" element={
          <Protected>
            <Layout>
              <OrganisationDetails />
            </Layout>
          </Protected>
        } />
        <Route path="/instance/details/:id" element={
          <Protected>
            <Layout>
              <InstanceDetails />
            </Layout>
          </Protected>
        } />
        <Route path="/tenant/details/:id" element={
          <Protected>
            <Layout>
              <TenantDetails />
            </Layout>
          </Protected>
        } />
        <Route path="/tax-invoice/details/:id" element={
          <Protected>
            <Layout>
              <TaxInvoiceDetails />
            </Layout>
          </Protected>
        } />
        <Route
          path="/client"
          element={
            <Protected>
              <Layout>
                <ClientList type="client" />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/vendor"
          element={
            <Protected>
              <Layout>
                <ClientList type="vendor" />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/organisation"
          element={
            <Protected>
              <Layout>
                <OrganisationList />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/lead"
          element={
            <Protected>
              <Layout>
                <LeadList />
              </Layout>
            </Protected>
          }
        />
        <Route path="/lead/details/:id" element={
          <Protected>
            <Layout>
              <LeadDetails />
            </Layout>
          </Protected>
        } />
        <Route path="/activity/details/:id" element={
          <Protected>
            <Layout>
              <ActivityDetails />
            </Layout>
          </Protected>
        } />
        <Route
          path="/deal"
          element={
            <Protected>
              <Layout>
                <DealsbyStage />
              </Layout>
            </Protected>
          }
        />
        <Route path="/deal/details/:id" element={
          <Protected>
            <Layout>
              <DealDetails />
            </Layout>
          </Protected>
        } />
        <Route path="/orders" element={
          <Protected>
            <Layout>
              <OrderDealList />
            </Layout>
          </Protected>
        } />
        <Route
          path="/invoices"
          element={
            <Protected>
              <Layout>
                <InvoiceList />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/partner"
          element={
            <Protected>
              <Layout>
                <PartnerList />
              </Layout>
            </Protected>
          }
        />
        <Route path="/partner/details/:id" element={
          <Protected>
            <Layout>
              <PartnerDetails />
            </Layout>
          </Protected>
        } />

        <Route path="/contact/details/:id" element={
          <Protected>
            <Layout>
              <SelectedContactDetails />
            </Layout>
          </Protected>
        } />
        <Route path="/contact-type" element={
          <Protected>
            <Layout>
              <ContactTypeDetails />
            </Layout>
          </Protected>
        } />
        <Route path="/contacts" element={
          <Protected>
            <Layout>
              <ContactsDetails />
            </Layout>
          </Protected>
        } />
        <Route path="/contacts/client/details/:id" element={
          <Protected>
            <Layout>
              <ClientDetails />
            </Layout>
          </Protected>
        } />
        <Route path="/proformainvoice/tax-details/:id" element={
          <Protected>
            <Layout>
              <TaxDetailsList />
            </Layout>
          </Protected>
        } />
        <Route path="/contacts/vendor/details/:id" element={
          <Protected>
            <Layout>
              <VendorDetails type="vendor" />
            </Layout>
          </Protected>
        } />
        <Route path="/contacts/lead/details/:id" element={
          <Protected>
            <Layout>
              <VendorDetails type="lead" />
            </Layout>
          </Protected>
        } />
        <Route path="/contacts/manager/details/:id" element={
          <Protected>
            <Layout>
              <VendorDetails type="manager" />
            </Layout>
          </Protected>
        } />
        <Route
          path="/product"
          element={
            <Protected>
              <Layout>
                <ProductList />
              </Layout>
            </Protected>
          }
        />
        <Route path="/product/details/:id" element={
          <Protected>
            <Layout>
              <ProductDetails />
            </Layout>
          </Protected>
        } />
        <Route path="/expense-type" element={
          <Protected>
            <Layout>
              <ExpenseTypeDetails />
            </Layout>
          </Protected>
        } />
        <Route path="/bank-accounts" element={
          <Protected>
            <Layout>
              <BankList />
            </Layout>
          </Protected>
        } />
        <Route path="/bank-accounts/details/:id" element={
          <Protected>
            <Layout>
              <BankDetails />
            </Layout>
          </Protected>
        } />
        <Route path="/transactions" element={
          <Protected>
            <Layout>
              <TransactionList />
            </Layout>
          </Protected>
        } />
        <Route path="/purchase-order/details/:id" element={
          <Protected>
            <Layout>
              <PurchaseOrderDetails />
            </Layout>
          </Protected>
        } />
        <Route path="/purchase-order" element={
          <Protected>
            <Layout>
              <PurchaseOrderList />
            </Layout>
          </Protected>
        } />
        <Route
          path="/tenant"
          element={
            <Protected>
              <Layout>
                <TenantList />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/project"
          element={
            <Protected>
              <Layout>
                <ProjectList />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/quotation"
          element={
            <Protected>
              <Layout>
                <QuotationList />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/proformainvoice"
          element={
            <Protected>
              <Layout>
                <ProformaInvoiceList />
              </Layout>
            </Protected>
          }
        />
        <Route path="/quotation/details/:id" element={
          <Protected>
            <Layout>
              <QuotationDetails />
            </Layout>
          </Protected>
        } />
        <Route path="/proformainvoice/details/:id" element={
          <Protected>
            <Layout>
              <ProformaInvoiceDetails />
            </Layout>
          </Protected>
        } />
        <Route path="/project/details/:id" element={
          <Protected>
            <Layout>
              <ProjectDetails />
            </Layout>
          </Protected>
        } />
        <Route
          path="/industries"
          element={
            <Protected>
              <Layout>
                <IndustryDetails />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/categories"
          element={
            <Protected>
              <Layout>
                <CategoryDetails />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/brands"
          element={
            <Protected>
              <Layout>
                <BrandDetails />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/license-types"
          element={
            <Protected>
              <Layout>
                <LicenseTypeList />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/deal-stages"
          element={
            <Protected>
              <Layout>
                <DealStageList />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/licenses"
          element={
            <Protected>
              <Layout>
                <LicenseList />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/license/details/:id"
          element={
            <Protected>
              <Layout>
                <LicenseView />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/profile"
          element={
            <Protected>
              <Layout>
                <Profile />
              </Layout>
            </Protected>
          }
        />

        <Route
          path="/sales-dashboard"
          element={
            <Protected>
              <Layout>
                <SalesDashboard />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/account-dashboard"
          element={
            <Protected>
              <Layout>
                <AccountDashboard />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/operation-dashboard"
          element={
            <Protected>
              <Layout>
                <OperationDashboard />
              </Layout>
            </Protected>
          }
        />
        <Route
          path="/sales-target-assignment"
          element={
            <Protected>
              <Layout>
                <SalesTargetAssignment />
              </Layout>
            </Protected>
          }
        />
        <Route path="/tax" element={<Protected> <Layout> <TaxList /></Layout></Protected>} />
        <Route path="/balancesheet" element={<Protected> <Layout> <Balancesheet /></Layout></Protected>} />
        <Route path="/profitandloss" element={<Protected> <Layout> <ProfitAndLoss /></Layout></Protected>} />
        <Route path="/trialbalance" element={<Protected> <Layout> <TrialBalance /></Layout></Protected>} />
        <Route path="/ledgerstatement" element={<Protected> <Layout> <LedgerStatement /></Layout></Protected>} />
        <Route path="/receivable-aging-report" element={<Protected> <Layout> <ReceivableAgingReport /></Layout></Protected>} />
        <Route path="/payable-aging-report" element={<Protected> <Layout> <PayableAgingReport /></Layout></Protected>} />
        <Route path="/expense-report" element={<Protected> <Layout> <ExpenseReport /></Layout></Protected>} />
        <Route path="/bank-reconciliation-report" element={<Protected> <Layout> <ReconciliationReport /></Layout></Protected>} />
        <Route path="/home" element={<Protected> <Layout> <FrstPage /></Layout></Protected>} />
        <Route path="/employee" element={<Protected> <Layout> <EmployeeList /></Layout></Protected>} />
        <Route path="/employee/details/:id" element={<Protected> <Layout> <EmployeeDetails /></Layout></Protected>} />
        <Route path="/allowance" element={<Protected> <Layout> <AllowanceList /></Layout></Protected>} />
        <Route path="/attendance" element={<Protected> <Layout> <AttendanceReport /></Layout></Protected>} />
        <Route path="/leave-type" element={<Protected> <Layout> <LeaveTypeList /></Layout></Protected>} />
        <Route path="/leave-entitlement" element={<Protected> <Layout> <LeaveEntitlement /></Layout></Protected>} />
        <Route path="/leave-application" element={<Protected> <Layout> <LeaveApplication /></Layout></Protected>} />
        <Route path="/pending-leave" element={<Protected> <Layout> <PendingLeave /></Layout></Protected>} />
        <Route path="/holiday-list" element={<Protected> <Layout> <HolidayList /></Layout></Protected>} />
        <Route path="/prefix" element={<Protected> <Layout> <PrefixList /></Layout></Protected>} />
        <Route path="/employee-event" element={<Protected> <Layout> <EmployeeEvent /></Layout></Protected>} />
        <Route path="/loan" element={<Protected> <Layout> <LoanList /></Layout></Protected>} />
        <Route path="/loan-approval" element={<Protected> <Layout> <PendingLoan /></Layout></Protected>} />
        <Route path="/deductions" element={<Protected> <Layout> <DeductionList /></Layout></Protected>} />
        <Route path="/overtimes" element={<Protected> <Layout> <OvertimeList /></Layout></Protected>} />
        <Route path="/payroll" element={<Protected> <Layout> <PayrollCycleList /></Layout></Protected>} />
        <Route path="/overtime-approval" element={<Protected> <Layout> <PendingOT /></Layout></Protected>} />
        <Route path="/overtime-types" element={<Protected> <Layout> <OvertimeTypeList /></Layout></Protected>} />
        <Route path="/revenue-list" element={<Protected> <Layout> <RevenueRecognitionReport /></Layout></Protected>} />
        <Route path="/revenue-report" element={<Protected> <Layout> <RevenueRecognitionList /></Layout></Protected>} />
        <Route path="/expense-recognition" element={<Protected> <Layout> <ExpenseRecognitionReport /></Layout></Protected>} />
        <Route path="/receivable-report" element={<Protected> <Layout> <ReceivableReport /></Layout></Protected>} />
        <Route path="/statement-of-accounts" element={<Protected> <Layout> <StatementOfAccounts /></Layout></Protected>} />
        <Route path="/partner-soa" element={<Protected> <Layout> <PartnerSOA /></Layout></Protected>} />
        <Route path="/product-pricing" element={<Protected> <Layout> <ProductPricing /></Layout></Protected>} />
        <Route path="/amc-setting" element={<Protected> <Layout> <AMCSettings /></Layout></Protected>} />
        <Route path="/quotation-list" element={<Protected> <Layout> <AllQuotation /></Layout></Protected>} />
        <Route path="/bank-details" element={<Protected> <Layout> <BankDetailList /></Layout></Protected>} />
        <Route path="/po-list" element={<Protected> <Layout> <PODetails /></Layout></Protected>} />
        <Route path="/permission" element={<Protected><Layout><PermissionDetails /></Layout></Protected>} />
        <Route path="/departments" element={<Protected><Layout><DepartmentList /></Layout></Protected>} />
        <Route path="/chart-of-accounts" element={<Protected> <Layout> <ChartOfAccounts /></Layout></Protected>} />
        <Route path="/activity-logs" element={<Protected> <Layout> <ActivityLogs /></Layout></Protected>} />
        <Route path="/cashflow-statement" element={<Protected> <Layout> <CashFlowStatement /></Layout></Protected>} />
        <Route path="/financial-lock" element={<Protected> <Layout> <FinancialLock /></Layout></Protected>} />
        <Route path="/payroll-providers" element={<Protected> <Layout> <PayrollProviderDetails /></Layout></Protected>} />
        <Route path="/activity-type" element={<Protected> <Layout> <ActivityTypeList /></Layout></Protected>} />

        <Route path="/vat-return" element={<Protected> <Layout> <VATPaymentDetails /></Layout></Protected>} />
        <Route path="/po-list" element={<Protected> <Layout> <PODetails /></Layout></Protected>} />
        <Route path="/settings/entrytypes" element={<Protected> <Layout> <EntryTypeList /></Layout></Protected>} />
        <Route path="/import-export-data" element={<Protected> <Layout> <ImportExportList /></Layout></Protected>} />
        <Route path="/domain" element={<Protected> <Layout> <DomainList /></Layout></Protected>} />
        <Route path="/dashboard/license" element={<Protected><Layout><LicenseDashboard /></Layout></Protected>} />
        <Route path="/license-keys" element={<Protected><Layout><LicenseKeyList /></Layout></Protected>} />
















        {/* Redirects */}


      </Routes>


    </Router>

  );
}

export default App;


